import { useEffect, useRef } from 'react'

interface LongPressOptions {
    onLongPress: () => void
    onPressEnd?: () => void
    delay?: number
}

export function useLongPress(options: LongPressOptions) {
    const { onLongPress, onPressEnd, delay = 500 } = options
    const timeoutRef = useRef<NodeJS.Timeout>()

    const handlePointerDown = () => {
        timeoutRef.current = setTimeout(onLongPress, delay)
    }

    const handlePointerUp = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
            onPressEnd?.()
        }
    }

    const attachListeners = (element: HTMLElement | null) => {
        if (!element) return

        element.addEventListener('pointerdown', handlePointerDown)
        element.addEventListener('pointerup', handlePointerUp)
        element.addEventListener('pointerleave', handlePointerUp)

        return () => {
            element.removeEventListener('pointerdown', handlePointerDown)
            element.removeEventListener('pointerup', handlePointerUp)
            element.removeEventListener('pointerleave', handlePointerUp)
        }
    }

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [])

    return { attachListeners }
}